import headerInit from './components_js/header';
import footerInit from "./components_js/footer.js";
// import cookiesInit from "./components_js/cookies";
// import footerInit from "./components_js/footer.js";

document.addEventListener("DOMContentLoaded", () => {

    // console.log('app.js');
    headerInit();
    footerInit();
    //
    // const { setCookieInit } = cookiesInit();
    // setCookieInit();
    //
    // footerInit();

});
